import { withInstall } from '@tav-ui/utils/with-install'
import Follow from './src/follow.vue'
const TaFollow = withInstall(Follow)
export { TaFollow }
export default TaFollow
export * from './src/types'
